import React, { FC } from "react";

import * as Styled from "./opening-hours.styled";
import { IOpeningTimes } from "./opening-hours.types";

export const OpeningHours: FC<IOpeningTimes> = ({ data }) => {
  return (
    <Styled.OpeningTimesWrapper>
      {data.map(({ day, time }, index) => (
        <Styled.OpeningTimesRow key={`${day}-${index}`}>
          <Styled.OpeningTimesDay>{day}</Styled.OpeningTimesDay>
          <Styled.OpeningTimesTime>{time}</Styled.OpeningTimesTime>
        </Styled.OpeningTimesRow>
      ))}
    </Styled.OpeningTimesWrapper>
  );
};
